import { Link, useLocation } from 'react-router-dom'
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList
} from '@quest-lock/ui/navigation-menu'
import { NavigationMenuProps } from '@radix-ui/react-navigation-menu'
import { useAuth0 } from '@auth0/auth0-react'
import { Key, Asterisk } from 'lucide-react'
import { cn } from '@/lib/utils'
import { appRoutes } from '@/constants'

interface NavItem {
  label: string
  href: string
  icon: React.ComponentType<{ className?: string }>
  requiresAuth?: boolean
}

const navItems: NavItem[] = [
  { label: 'Authenticator', href: appRoutes.home, icon: Key },
  {
    label: 'Password Generator',
    href: appRoutes.passwordGenerator,
    icon: Asterisk
  }
]

export default function NavMenu(props: NavigationMenuProps) {
  const { isAuthenticated } = useAuth0()
  const location = useLocation()

  const filteredNavItems = navItems.filter(
    item => !item.requiresAuth || isAuthenticated
  )

  return (
    <NavigationMenu {...props}>
      <NavigationMenuList className="font-body gap-6 space-x-0 data-[orientation=vertical]:flex-col data-[orientation=vertical]:items-start data-[orientation=vertical]:gap-2">
        {filteredNavItems.map(item => {
          const Icon = item.icon
          const isActive = location.pathname === item.href

          return (
            <NavigationMenuItem key={item.href}>
              <NavigationMenuLink asChild>
                <Link
                  to={item.href}
                  className={cn(
                    'flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium transition-all duration-200 data-[orientation=vertical]:w-full data-[orientation=vertical]:justify-start data-[orientation=vertical]:px-4 data-[orientation=vertical]:py-3',
                    isActive
                      ? 'bg-shire-sun/20 text-shire-dark ring-shire-sun/30 ring-2'
                      : 'text-shire-bark hover:text-shire-dark hover:bg-white/60'
                  )}
                >
                  <Icon className="size-4 data-[orientation=vertical]:size-5" />
                  <span>{item.label}</span>
                  {isActive && (
                    <div className="bg-shire-sun ml-auto size-2 rounded-full data-[orientation=horizontal]:hidden" />
                  )}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>
          )
        })}
      </NavigationMenuList>
    </NavigationMenu>
  )
}
